import type { Documents } from '../../types/Documents';

export const documentsBaseFeatureConfig: Documents = {
    documentsUrlConfig: 'prestoUrl',
    filterMarketDataDocument: false,
    requestForTitleDocuments: false,
    tokenForDocuments: false,
};
